import React, { createContext, useContext, useEffect, useState } from "react"; // Import React and hooks
import { Urls } from "./Urls"; // Import URLs from Urls file
import { auth } from "./Components/firebase/firebase"; // Import auth object from Firebase setup
import Axios from "./Axios"; // Import Axios instance

// Create a context for user data
export const UserDataContext = createContext({});

// Provider component to manage and provide user data
export const UserDataProvider = ({ children }) => {
  const [userData, setUserData] = useState({}); // State to store user data

  const fetchUserData = () => {
    Axios.get(Urls.user_data) // Make GET request to fetch user data
      .then((res) => {
        // Store data in localStorage and update state
        localStorage.setItem(
          "companyname",
          res.data.company_name
            ? res.data.company_name
            : res.data.email
            ? res.data.email.split("@")[1].split(".")[0]
            : ""
        );
        localStorage.setItem("profile_company_id", res.data.profile_company_id);
        setUserData(res.data);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    // Fetch user data when component mounts
    if (auth && auth.currentUser && auth.currentUser.getIdToken()) {
      // Handle errors
      fetchUserData();
    }
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <UserDataContext.Provider value={[userData, setUserData, fetchUserData]}>
      {children} {/* Render child components with user data context */}
    </UserDataContext.Provider>
  );
};

// Custom hook to use user data context
export function useUser() {
  return useContext(UserDataContext);
}
